module.exports = __webpack_public_path__ + "img/esc_3_act_3.04a455ef.png";